module.exports = __webpack_public_path__ + "static/media/ban-khar-mission.db3f9997.svg";